/* unplugin-vue-components disabled */var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "timeline-item"
  }, [_c('div', {
    staticClass: "timeline-item-left"
  }, [_vm._m(0), _vm.dash ? _c('div', {
    staticClass: "dash"
  }, [_c('div', {
    staticClass: "dash-line"
  })]) : _vm._e()]), _c('div', {
    staticClass: "timeline-item-right"
  }, [_c('div', {
    staticClass: "title-and-date"
  }, [_c('div', {
    staticClass: "title font-size-h3-large"
  }, [_vm._t("title")], 2), _c('div', {
    staticClass: "date font-size-h4-normal"
  }, [_vm._t("date")], 2)]), _c('div', {
    staticClass: "content font-size-h3-normal"
  }, [_vm._t("content")], 2)])]);
};
var staticRenderFns = [function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "circle"
  }, [_c('div', {
    staticClass: "circle-inside"
  })]);
}];
export { render, staticRenderFns };